import { render, staticRenderFns } from "./WorkerReportManager.vue?vue&type=template&id=2cf81658&"
import script from "./WorkerReportManager.vue?vue&type=script&lang=js&"
export * from "./WorkerReportManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports